import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import Select from 'react-select';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const ContributorTypeEditor = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_EmployeeContract)
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDContributorType === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDContributorType,
                    label: `${found.DataBeanProperties.Description}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);


    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(null);
        } else {

            if (onChange) {
                onChange(option.value);
            }
        }
    };

    const getLista = () => {

        instance.getContributorTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(e => { toast.error(e) })

    }

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDContributorType,
        label: `${item.DataBeanProperties.Description}`,
        item: item
    }));

    return (
        <div>
            {label && label != " "?
                < label > {label ?? "Tipo de Cotizante"}</label>
                :
                <label>Tipo de Cotizante</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder={`Selecciona un ${label}...`}
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
}